import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertMentorshipsMutationVariables = Types.Exact<{
  objects: Array<Types.Mentorship_Insert_Input> | Types.Mentorship_Insert_Input;
}>;


export type InsertMentorshipsMutation = { __typename?: 'mutation_root', insert_mentorship?: { __typename?: 'mentorship_mutation_response', returning: Array<{ __typename?: 'mentorship', id: any }> } | null };


export const InsertMentorshipsDocument = gql`
    mutation insertMentorships($objects: [mentorship_insert_input!]!) {
  insert_mentorship(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type InsertMentorshipsMutationFn = Apollo.MutationFunction<InsertMentorshipsMutation, InsertMentorshipsMutationVariables>;

/**
 * __useInsertMentorshipsMutation__
 *
 * To run a mutation, you first call `useInsertMentorshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMentorshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMentorshipsMutation, { data, loading, error }] = useInsertMentorshipsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertMentorshipsMutation(baseOptions?: Apollo.MutationHookOptions<InsertMentorshipsMutation, InsertMentorshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMentorshipsMutation, InsertMentorshipsMutationVariables>(InsertMentorshipsDocument, options);
      }
export type InsertMentorshipsMutationHookResult = ReturnType<typeof useInsertMentorshipsMutation>;
export type InsertMentorshipsMutationResult = Apollo.MutationResult<InsertMentorshipsMutation>;
export type InsertMentorshipsMutationOptions = Apollo.BaseMutationOptions<InsertMentorshipsMutation, InsertMentorshipsMutationVariables>;